import { defineMessages } from 'react-intl';
import { BATCH_BY_ORDER_COUNT, BATCH_BY_BATCH_COUNT } from './constants/auto-batching-constants';

export default defineMessages({
  [BATCH_BY_ORDER_COUNT]: {
    description: 'Validation error message for Auto Batching number of records per batch',
    defaultMessage: 'A batch can have a maximum of {maxAllowedOrdersPerBatch} orders.',
    id: 'fl6xFD',
  },
  [BATCH_BY_BATCH_COUNT]: {
    description: 'Validation error message for Auto Batching number of batches',
    defaultMessage: 'Exceeds limit.',
    id: 'wU79IM',
  },
  autoBatchTotalOrdersExceeded: {
    description: "Validation error message for Auto Batching number of batches shouldn't exceed selected orders",
    defaultMessage: 'Cannot exceed number of Selected Orders.',
    id: 'ZHLPGR',
  },
});
